import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import HeatBlock from '@learningblocks/exp-constants/lib/Images/heatBlock.svg';
import Tube from '@learningblocks/exp-constants/lib/Images/Tube.svg';

import style from './style.module.scss';

export function HeatBlockImage(props) {
  const renderTube = (slotId) => {
    const tube = props.slots[slotId].tube;
    return tube ? <Image src={Tube} /> : null;
  };
  return (
    <>
      <div className={style.heatBlockImage}>
        <div className={style.heatBlockImage_one}>{renderTube(0)}</div>
        <div className={style.heatBlockImage_two}>{renderTube(1)}</div>
        <div className={style.heatBlockImage_three}>{renderTube(2)}</div>
        <div className={style.heatBlockImage_four}>{renderTube(3)}</div>
      </div>
      <Image
        src={HeatBlock}
        alt='Heat-Block'
        className={style.heatBlockImage_img}
      />
    </>
  );
}
HeatBlockImage.propTypes = {
  /**
   * Slots are the array which represent the filing of tube
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * It defines the number of slot in the heatblock
       */
      slotId: PropTypes.number.isRequired,
      /**
       * It defines the number of slot in the heatblock
       */
      tube: PropTypes.bool,
    })
  ).isRequired,
};
